import React from 'react';
import './BettingDetails.css';
import InnerHeader from '../../components/InnerHeader';
import { useLocation, useNavigate } from 'react-router-dom';

const BettingDetails = ({ betData, onBack }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get data from navigation state or props
  const passedData = location.state?.betDetails || betData;
  
  // Fallback to sample data if no data provided
  const detailsData = passedData || {
    sport: 'Exchange',
    icon: 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'40\' height=\'40\' viewBox=\'0 0 40 40\'%3E%3Crect width=\'40\' height=\'40\' rx=\'20\' fill=\'%23333\'/%3E%3Ctext x=\'20\' y=\'25\' font-family=\'Arial\' font-size=\'20\' fill=\'%23FF6B35\' text-anchor=\'middle\'%3E🏏%3C/text%3E%3C/svg%3E',
    badge: 'Table',
    date: '2026-02-09',
    details: {
      sport: 'Exchange',
      totalTurnover: '90.00',
      transactions: [
        {
          id: 1,
          name: '7up 7down',
          turnover: '30.00',
          result: '-30.00',
          timestamp: '2026-02-09 03:58:30'
        }
      ]
    }
  };

  // Extract values from the data structure
  const sportName = detailsData.sport || detailsData.details?.sport;
  const sportIcon = detailsData.icon;
  const badgeName = detailsData.badge;
  const dateValue = detailsData.date;
  const totalTurnover = detailsData.details?.totalTurnover || detailsData.turnover;
  const transactions = detailsData.details?.transactions || [];

  // Calculate total result (profit/loss)
  const totalResult = transactions.reduce((sum, txn) => {
    return sum + (parseFloat(txn.result) || 0);
  }, 0);

  return (
    <div className="betdet-container">
      {/* Header */}
      <InnerHeader title='Details'/>

      {/* Sport Info */}
      <div className="betdet-sport-section">
        <div className="betdet-icon-wrapper">
          <img 
            src={sportIcon}
            alt={sportName} 
            className="betdet-sport-icon"
          />
        </div>
        <div className="betdet-sport-info">
          <span className="betdet-sport-name">{sportName}</span>
          <span className="betdet-badge">{badgeName}</span>
        </div>
      </div>

      {/* Date */}
      <div className="betdet-date-wrapper">
        <div className="betdet-date">{dateValue}</div>
      </div>

      {/* Turnover Card */}
      <div className="betdet-turnover-card">
        <div className="betdet-turnover-row">
          <div className="betdet-turnover-item">
            <div className="betdet-turnover-label">Turnover</div>
            <div className="betdet-turnover-value">{totalTurnover}</div>
          </div>
          <div className="betdet-turnover-item">
            <div className="betdet-turnover-label">Profit/Loss</div>
            <div 
              className="betdet-turnover-value"
              style={{ 
                color: totalResult >= 0 ? '#4CAF50' : '#f44336' 
              }}
            >
              {totalResult >= 0 ? '+' : ''}{totalResult.toFixed(2)}
            </div>
          </div>
        </div>
      </div>

      {/* Transactions List */}
      <div className="betdet-transactions">
        <div className="betdet-transactions-header">
          <h3>Transactions ({transactions.length})</h3>
        </div>
        
        {transactions.length > 0 ? (
          transactions.map((transaction, index) => (
            <div key={transaction.id || index} className="betdet-transaction-item">
              <div className="betdet-transaction-left">
                <div className="betdet-transaction-name">{transaction.name}</div>
                <div className="betdet-transaction-turnover">
                  {transaction.turnover} <span className="betdet-transaction-turnover-label">Turnover</span>
                </div>
              </div>
              <div className="betdet-transaction-right">
                <div className="betdet-transaction-timestamp">{transaction.timestamp}</div>
                <div 
                  className={`betdet-transaction-result ${parseFloat(transaction.result) >= 0 ? 'positive' : 'negative'}`}
                >
                  {parseFloat(transaction.result) >= 0 ? '+' : ''}{transaction.result}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="betdet-no-transactions">
            <p>No transactions found</p>
          </div>
        )}
      </div>

      {/* Bottom Logo */}
     
    </div>
  );
};

export default BettingDetails;